<template>
	<ul v-if="errors.length > 0" class="form-errors">
		<li v-for="error in errors" :key="error" class="form-error">
			<label v-if="props.for.length > 0" :for="props.for">
				<IconSvg icon="alert" />
				{{ error }}
			</label>
			<template v-else>
				<IconSvg icon="alert" />
				{{ error }}
			</template>
		</li>
	</ul>
</template>

<script lang="ts" setup>
	import type {PropType} from 'vue';
	import IconSvg from '~/components/generic/IconSvg.vue';

	const props = defineProps({
		for: {
			type: String,
			default: ''
		},
		errors: {
			type: Array as PropType<string[]>,
			default: () => []
		}
	});
</script>

<style scoped>
	ul {
		padding: 10px 16px;
		margin: 4px 0 0;

		background: var(--color-error-light);
		color: var(--color-grey-500);

		font-size: 13px;
		line-height: 16px;

		--icon-color: var(--color-error);
		--icon-size: 16px;
	}

	li {
		list-style: none;
	}

	/* FIXME: icon margin + alignment */
</style>
